export default __webpack_public_path__ + "static/media/Women_Sizing_Chart.41334ebc.png";